// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__KbRdG","colCheckbox":"styles_colCheckbox__3PiEK"};